import _compose from "ramda/es/compose";
import snsEventRawMessage from './snsEventRawMessage';
import safeParse from './safeParse';
export default _compose(safeParse, snsEventRawMessage);